import CryptoJS from "crypto-js";
const secretKey = process.env.REACT_APP_SECRET_KEY;
export const encryptValue = (value) => {
    if (value) {
        return CryptoJS.AES.encrypt(String(value), secretKey).toString();
    }
    return "";
};

export const decryptValue = (encryptedValue) => {
    try {
        if (!encryptedValue) {
            return null;
        }
        const bytes = CryptoJS.AES.decrypt(encryptedValue, secretKey);
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
        return decryptedValue;
    } catch (error) {
        console.error("Decryption failed:", error);
        return null;
    }
};

